export default {
    message: {
        currencySymbol: "$",
        currencyDesc: "USD",
        tiers: {
            t1: {
                label: "Workspace Standard",
                desc: "<p>Oferta principal de Workspace con funciones inteligentes para los trabajadores modernos que utilizan SaaS, aplicaciones web y servicios de uso compartido de archivos.</p><p>Incluye inicio de sesión único compatible con autenticación multifactor para todas las aplicaciones; inteligencia en el espacio de trabajo con microaplicaciones, canales personalizados y asistencia virtual; también el servicio Citrix Content Collaboration Standard con almacenamiento ilimitado de archivos.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Solución de espacio de trabajo completa para los trabajadores que necesitan un espacio de trabajo digital completo con seguridad granular, pero que no requieren aplicaciones y escritorios virtuales.</p><p>Incluye la funcionalidad Workspace Standard, más controles de seguridad avanzados para SaaS y web, gestión de terminales unificada y Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Solución de espacio de trabajo completa que incluye opciones de implementación híbrida para Citrix Virtual Apps and Desktops.</p><p>Incluye la funcionalidad Workspace Premium más una opción de administración en la nube para Citrix Virtual Apps and Desktops.</p>"
            },
            t4: {
                label: "Workspace Essentials",
                desc: "<p>Citrix Workspace Essentials ayuda a las empresas pequeñas y medianas a proteger sus datos simplificando y protegiendo el proceso de inicio de sesión en aplicaciones web y SaaS.</p><p>Incluye un inicio de sesión único en aplicaciones web y SaaS con autenticación multifactor para proteger aún más el proceso de inicio de sesión, reduciendo así en un 99,9 % las posibilidades de intrusión en la cuenta.</p>"
            },
            terms: "*Por usuario y mes",
            btn1: "Ver matriz de características"
        },
        features: {
            disclaimer1: "*PVP mensual promedio en USD por usuario para una suscripción de 3 años de 500 usuarios. El precio real puede variar.<br /> Opciones de licencia de Citrix Workspace a partir de 25 usuarios.",
            disclaimer2: "**El servicio Workspace Premium no incluye Workspace Analytics para implementaciones de Citrix Virtual Apps and Desktops en las instalaciones."
        },
        calculator: {
            edition: "Seleccione su edición",
            title: "Calcule sus precios",
            users: "Seleccione a sus usuarios",
            estCost: "Su coste mensual calculado",
            btn1: "Hable con un experto",
            btn1_link: "/products/citrix-workspace/form/pricing-inquiry/",
            minUserMsg: "Opciones de licencia a partir de 25 usuarios. Vuelva a intentarlo.",
            lowUserMsg: "¿Tiene menos de 500 usuarios? Podemos ayudarle con las necesidades de su empresa pequeña o mediana.",
            volumeDiscount: "¿Más de 2500 usuarios? Disfrute de precios con descuento por volumen.",
            contract1: "Contrato de 1 año",
            contract3: "Contrato de 3 años",
            contract3savings: "20 % de ahorro",
            term: "Por usuario y mes",
            disclaimer: "*Esta calculadora proporciona precios estimados y solo puede usarse para realizar presupuestos. Los precios reales pueden variar. Póngase en contacto con su equipo o socio de Citrix para conocer los descuentos aplicables."
        },
        stats: {
            title: "Sus beneficios",
            stat1: {
                title: "Mejore la experiencia de los empleados",
                desc: "<b>4 de cada 5</b> líderes de TI creen que la experiencia de los empleados es vital para su transformación digital."
            },
            stat2: {
                title: "Deje que los empleados elijan",
                desc: "El <b>78 %</b> de los líderes empresariales está de acuerdo en que permitir a los empleados elegir las aplicaciones y dispositivos que usan ayuda a mejorar su experiencia."
            },
            stat3: {
                title: "Simplifique el acceso",
                desc: "El <b>47 %</b> de los líderes empresariales dice que la mayor contribución al compromiso de los empleados es facilitar el acceso a la información necesaria para trabajar."
            },
            btn1: "Hable con un experto",
            disclaimer: "Fuente: <a href='https://theexperienceofwork.economist.com/Citrix_The_Experience_of_Work_BriefingPaper.pdf' target='_blank'>The Economist</a>"
        }
    }
}